import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBanknote1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconBanknote1"><Path fillRule="evenodd" clipRule="evenodd" d="M1 5.25C1 4.83579 1.33579 4.5 1.75 4.5H22.25C22.6642 4.5 23 4.83579 23 5.25V18.75C23 19.1642 22.6642 19.5 22.25 19.5H1.75C1.33579 19.5 1 19.1642 1 18.75V5.25ZM3 7V8.5H5.5V7H3ZM18.5 15.5H21V17H18.5V15.5ZM9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBanknote1;
